module.exports = __webpack_public_path__ + "static/media/counsel.8f66a1a0.jpg";